import { SubmissionError, reset } from "redux-form";
import { closeModal } from "../modals/modalActions";
import { toastr } from "react-redux-toastr";
import firebase from "../../app/config/firebase";
import compareAsc from "date-fns/compare_asc";

import axios from "../../axios-firebase";
import {
  createNewMerchant,
  createNewCorporateMerchant,
  createNewOutlet,
  createRandomAccountNumber,
  createLuhnAccountNumber,
  createRandomPairingCode,
  createOutletUser,
  hashPassword,
  createMerchantComputerObject,
  createOutletEmail,
  createMerchantEmail,
  createRandomString,
  createTransferFromMerchantObject,
  createTransferToMerchantObject,
} from "../../app/common/util/helpers";
import {
  CREATE_MERCHANT,
  UPDATE_MERCHANT,
  DELETE_MERCHANT,
  SELECT_MERCHANT,
  CREATE_OUTLET,
  FETCH_MERCHANTS,
} from "./merchantConstants";
import {
  asyncActionStart,
  asyncActionFinish,
  asyncActionError,
} from "../async/asyncActions";
import { validateMerchantPdfFile } from "./validateMerchantPdf";

export const selectMerchant = (account) => async (dispatch, getState) => {
  // let today = new Date(Date.now());
  const firestore = firebase.firestore();
  const merchantsRef = firestore.collection("merchants");
  try {
    dispatch(asyncActionStart());

    let query = merchantsRef.where("account", "==", account);

    let querySnap = await query.get();

    if (querySnap.docs.length === 0) {
      dispatch(asyncActionFinish());
      // return querySnap;
    }

    let merchant = querySnap.docs[0].data();

    ////console.log("merchant", merchant);

    dispatch({ type: SELECT_MERCHANT, payload: { merchant } });
    dispatch(asyncActionFinish());
  } catch (error) {
    ////console.log(error);
    dispatch(asyncActionError());
  }
};

export const createMerchant = (
  merchant,
  merchantAgreement,
  merchantOmang,
  merchantAffidavit,
  merchantHawkersLicense
) => {

  return async (dispatch, getState, { getFirebase, getFirestore }) => {
    dispatch(asyncActionStart());

    const firebase = getFirebase();
    const firestore = getFirestore();

    const currentUser = firebase.auth().currentUser.displayName;

    const dateCreated = new Date();
    /**
     * Generate ID
     */
    const currentUserBranch = getState().firebase.profile.branch;
    // 1 Generate MerchantAcc
    // let merchantAccount = await generateMerchantAccount(firestore);
    const merchantAccount = await createLuhnAccountNumber(8);

    // 2 Set the Id
    merchant.merchantAccount = merchantAccount;

    const outletId = `${merchantAccount}-01`;

    // 3 Add 01 to MerchantAcc to get OutletID
    merchant.merchant_outlet_outletId = outletId;

    let outlet = {
      city: merchant.merchantCity.value,
      name: merchant.merchantName,
      id: merchant.merchant_outlet_outletId,
      suburb: merchant.merchantSuburb,
      type: /* merchant.merchant_outlet_type.value, */ "Informal Trader",
      dateCreated: dateCreated,
      createdBy: currentUser,
      branch: currentUserBranch,
      contact: {
        email: merchant.merchant_contact_email,
        name: merchant.merchant_contact_name,
        telephone: merchant.merchant_contact_telephone,
      },
    };

    /**
     * END Generate ID
     */

    let newMerchant = createNewMerchant(merchant, currentUser, currentUserBranch);

    let transferObj = {};

    transferObj.values = {
      account: "2837",
      transactionType: "Transfer",
      transfer_to_account: newMerchant.referralCode,
      transfer_reason: `Referral programme reward for ${merchantAccount}`,
      merchantName: "Promotions",
      transferType: "Intra Merchant Transfer",
      isTransactionCharged: false,
      transfer_amount: 50.0,
    };

    let referralTransfer = createTransferFromMerchantObject(
      transferObj,
      currentUser
    );

    let referralTransferIn = createTransferToMerchantObject(
      transferObj,
      currentUser
    );

    let merchantCommission = {
      account: merchantAccount,
      name: newMerchant.name,
      electricity: {
        bpc: {
          provider: "Botswana Power Corporation",
          rate: /* parseFloat(merchant.electricity_bpc), */ 2.0,
          measurement: "Percentage",
        },
      },
      airtime: {
        beMobile: {
          provider: "beMobile",
          rate: /*  parseFloat(merchant.airtime_bemobile), */ 8.0,
          measurement: "Percentage",
        },
        mascom: {
          provider: "Mascom",
          rate: /* parseFloat(merchant.airtime_mascom), */ 7.0,
          measurement: "Percentage",
        },
        orange: {
          provider: "Orange",
          rate: /* parseFloat(merchant.airtime_orange), */ 8.0,
          measurement: "Percentage",
        },
      },
      // collections: {
      //   blil: {
      //     provider: "Botswana Life",
      //     rate: /* parseFloat(merchant.collections_botswanalife), */ 0.0,
      //     measurement: "Fixed",
      //   },
      // },
      bills: {
        bpc: {
          provider: "Botswana Power Corporation",
          rate: /* parseFloat(merchant.bill_BPC), */ 2.0,
          measurement: "Fixed",
        },
        dstv: {
          provider: "MultiChoice Botswana",
          rate: /* parseFloat(merchant.bill_DSTV), */ 1.5,
          measurement: "Fixed",
        },
        wuc: {
          provider: "Water Utilities Corporation",
          rate: /* parseFloat(merchant.bill_WUC), */ 3.0,
          measurement: "Fixed",
        },
        btc: {
          provider: "Botswana Telecommunications Corporation",
          rate: /* parseFloat(merchant.bill_BTCL), */ 0.0,
          measurement: "Fixed",
        },
      },
      payments: {
        dstv: {
          provider: "MultiChoice Botswana",
          rate: /*  parseFloat(merchant.bill_DSTV), */ 1.5,
          measurement: "Percentage",
        },
        wuc: {
          provider: "Water Utilities Corporation",
          rate: 3.0,
          measurement: "Fixed",
        },
        gambling: {
          provider: "Gambling",
          rate: /*  parseFloat(merchant.bill_Gambling), */ 1.5,
          measurement: "Percentage",
        },
        botswanalife: {
          provider: "Botswana Life",
          rate: 1.5,
          measurement: "Percentage",
        },
        assurewealth: {
          provider: "Assure Wealth",
          rate: 3.0,
          measurement: "Percentage",
        },
        myzakacashin: {
          measurement: "Of Vendor Commission",
          provider: "Myzaka cashin",
          rate: 70,
        },
        myzakacashout: {
          measurement: "Of Vendor Commission",
          provider: "Myzaka cashout",
          rate: 70,
        },
        badiphitlho: {
          provider: "Badiphitlho",
          rate: 3,
          measurement: "Percentage",
        }
      },
      schedule: "Monthly",
      frequency: "Monthly",
      isActive: true,
      dateCreated: dateCreated,
      createdBy: currentUser,
    };

    let merchantBalance = {
      account: merchantAccount,
      balance: 0,
      balanceBeforeTransaction: 0,
      dateCreated: dateCreated,
      createdBy: currentUser,
      isActiveBalance: true,
      transactionAmount: 0,
      transactionDateTime: dateCreated,
      transactionType: "Account Creation",
    };

    let merchantProviders = [
      {
        account: merchantAccount,
        type: "Airtime",
        provider: "Mascom-10",
        denomination: 10,
        name: newMerchant.name,
        isEnabled: true,
        dateCreated: dateCreated,
        createdBy: currentUser,
      },
      {
        account: merchantAccount,
        type: "Airtime",
        provider: "Mascom-20",
        denomination: 20,
        name: newMerchant.name,
        isEnabled: true,
        dateCreated: dateCreated,
        createdBy: currentUser,
      },
      {
        account: merchantAccount,
        type: "Airtime",
        provider: "Mascom-60",
        denomination: 60,
        name: newMerchant.name,
        isEnabled: true,
        dateCreated: dateCreated,
        createdBy: currentUser,
      },
      {
        account: merchantAccount,
        type: "Airtime",
        provider: "Mascom-100",
        denomination: 100,
        name: newMerchant.name,
        isEnabled: true,
        dateCreated: dateCreated,
        createdBy: currentUser,
      },
      {
        account: merchantAccount,
        type: "Airtime",
        provider: "Mascom Pinless",
        name: newMerchant.name,
        dateCreated: dateCreated,
        isEnabled: true,
        createdBy: currentUser,
        denomination: 0,
      },
      {
        account: merchantAccount,
        type: "Airtime",
        provider: "Orange Pinless",
        name: newMerchant.name,
        dateCreated: dateCreated,
        isEnabled: true,
        createdBy: currentUser,
        denomination: 0,
      },
      {
        account: merchantAccount,
        type: "Airtime",
        provider: "beMobile Pinless",
        name: newMerchant.name,
        dateCreated: dateCreated,
        isEnabled: true,
        createdBy: currentUser,
        denomination: 0,
      },
      {
        account: merchantAccount,
        type: "Airtime",
        provider: "Orange-10",
        denomination: 10,
        name: newMerchant.name,
        isEnabled: true,
        dateCreated: dateCreated,
        createdBy: currentUser,
      },
      {
        account: merchantAccount,
        type: "Airtime",
        provider: "Orange-20",
        denomination: 20,
        name: newMerchant.name,
        isEnabled: true,
        dateCreated: dateCreated,
        createdBy: currentUser,
      },
      {
        account: merchantAccount,
        type: "Airtime",
        provider: "Orange-50",
        denomination: 50,
        name: newMerchant.name,
        isEnabled: true,
        dateCreated: dateCreated,
        createdBy: currentUser,
      },
      {
        account: merchantAccount,
        type: "Airtime",
        provider: "Orange-100",
        denomination: 100,
        name: newMerchant.name,
        isEnabled: true,
        dateCreated: dateCreated,
        createdBy: currentUser,
      },
      {
        account: merchantAccount,
        type: "Airtime",
        provider: "Orange-250",
        denomination: 100,
        name: newMerchant.name,
        isEnabled: false,
        dateCreated: dateCreated,
        createdBy: currentUser,
      },
      {
        account: merchantAccount,
        type: "Airtime",
        provider: "Orange-500",
        denomination: 100,
        name: newMerchant.name,
        isEnabled: false,
        dateCreated: dateCreated,
        createdBy: currentUser,
      },
      {
        account: merchantAccount,
        type: "Airtime",
        provider: "beMobile-10",
        denomination: 10,
        name: newMerchant.name,
        isEnabled: true,
        dateCreated: dateCreated,
        createdBy: currentUser,
      },
      {
        account: merchantAccount,
        type: "Airtime",
        provider: "beMobile-20",
        denomination: 20,
        name: newMerchant.name,
        isEnabled: true,
        dateCreated: dateCreated,
        createdBy: currentUser,
      },
      {
        account: merchantAccount,
        type: "Airtime",
        provider: "beMobile-30",
        denomination: 30,
        name: newMerchant.name,
        isEnabled: true,
        dateCreated: dateCreated,
        createdBy: currentUser,
      },
      {
        account: merchantAccount,
        type: "Airtime",
        provider: "beMobile-50",
        denomination: 50,
        name: newMerchant.name,
        isEnabled: true,
        dateCreated: dateCreated,
        createdBy: currentUser,
      },
      {
        account: merchantAccount,
        type: "Airtime",
        provider: "beMobile-100",
        denomination: 100,
        name: newMerchant.name,
        isEnabled: true,
        dateCreated: dateCreated,
        createdBy: currentUser,
      },
      {
        account: merchantAccount,
        type: "Airtime",
        provider: "BTC",
        name: newMerchant.name,
        isEnabled: false,
        dateCreated: dateCreated,
        createdBy: currentUser,
      },
      {
        account: merchantAccount,
        type: "Electricity",
        provider: "BPC",
        name: newMerchant.name,
        isEnabled: true,
        dateCreated: dateCreated,
        createdBy: currentUser,
      },
      {
        account: merchantAccount,
        type: "Collections",
        provider: "BLIL",
        name: newMerchant.name,
        isEnabled: false,
        dateCreated: dateCreated,
        createdBy: currentUser,
      },
      {
        account: merchantAccount,
        type: "Bills",
        provider: "BTC",
        name: newMerchant.name,
        isEnabled: false,
        dateCreated: dateCreated,
        createdBy: currentUser,
      },
      {
        account: merchantAccount,
        type: "Bills",
        provider: "DSTV",
        name: newMerchant.name,
        isEnabled: false,
        dateCreated: dateCreated,
        createdBy: currentUser,
      },
      {
        account: merchantAccount,
        type: "Bills",
        provider: "WUC",
        name: newMerchant.name,
        isEnabled: false,
        dateCreated: dateCreated,
        createdBy: currentUser,
      },
      {
        account: merchantAccount,
        type: "Bills",
        provider: "BPC",
        name: newMerchant.name,
        isEnabled: false,
        dateCreated: dateCreated,
        createdBy: currentUser,
      },
      {
        account: merchantAccount,
        type: "Payments",
        provider: "MultiChoice Botswana",
        name: newMerchant.name,
        dateCreated: dateCreated,
        isEnabled: true,
        createdBy: currentUser,
        denomination: 0,
      },
      {
        account: merchantAccount,
        type: "Payments",
        provider: "Water Utilities Corporation",
        name: newMerchant.name,
        dateCreated: dateCreated,
        isEnabled: false,
        createdBy: currentUser,
        denomination: 0,
      },
      {
        type: "Payments",
        account: merchantAccount,
        name: newMerchant.name,
        provider: "Gambling",
        isEnabled: true,
        dateCreated: dateCreated,
        denomination: 0,
        createdBy: currentUser,
      },
      {
        type: "Payments",
        account: merchantAccount,
        name: newMerchant.name,
        provider: "Botswana Life",
        isEnabled: true,
        dateCreated: dateCreated,
        denomination: 0,
        createdBy: currentUser,
      },
      {
        type: "Payments",
        account: merchantAccount,
        name: newMerchant.name,
        provider: "Assure Wealth",
        isEnabled: false,
        dateCreated: dateCreated,
        denomination: 0,
        createdBy: currentUser,
      },
      {
        type: "Payments",
        account: merchantAccount,
        name: newMerchant.name,
        provider: "Myzaka cashout",
        isEnabled: false,
        dateCreated: dateCreated,
        denomination: 0,
        createdBy: currentUser,
      },
      {
        type: "Payments",
        account: merchantAccount,
        name: newMerchant.name,
        provider: "Myzaka cashin",
        isEnabled: false,
        dateCreated: dateCreated,
        denomination: 0,
        createdBy: currentUser,
      },
      {
        type: "Payments",
        account: merchantAccount,
        name: newMerchant.name,
        provider: "Badiphitlho",
        isEnabled: true,
        dateCreated: dateCreated,
        denomination: 0,
        createdBy: currentUser,
      },
    ];

    try {
      if (merchantAgreement) {
        await uploadMerchantAgreement(
          merchantAgreement,
          merchantAccount,
          firebase,
          dispatch
        );
      } else {
        throw new Error("Problem uploading merchant contract");
      }

      if (merchantOmang) {
        await uploadMerchantOmang(
          merchantOmang,
          merchantAccount,
          firebase,
          dispatch
        );
      } else {
        throw new Error("Problem uploading merchant contract");
      }

      if (merchantAffidavit) {
        await uploadMerchantAffidavit(
          merchantAffidavit,
          merchantAccount,
          firebase,
          dispatch
        );
      } else {
        throw new Error("Problem uploading merchant contract");
      }

      if (merchantHawkersLicense) {
        await uploadMerchantHawkersLicense(
          merchantHawkersLicense,
          merchantAccount,
          firebase,
          dispatch
        );
      }
      dispatch(asyncActionStart());

      // Create a ref with auto-generated ID
      let newMerchantRef = firestore
        .collection("merchants")
        .doc(merchantAccount);

      let merchantCommissionRef = firestore
        .collection("merchant_commission")
        .doc();
      // let merchantEmailRef = firestore.collection("scheduleEmails").doc();
      // let outletEmailRef = firestore.collection("scheduleEmails").doc();

      let merchantAPIKeyRef = firestore.collection("api_key").doc();

      newMerchantRef.collection("outlets").doc(outletId).set(outlet);

      let merchantBalanceRef = firestore.collection("merchant_balance").doc();

      newMerchant.id = newMerchantRef.id;
      merchantCommission.merchantId = newMerchantRef.id;
      merchantBalance.reference = merchantBalanceRef.id;

      let merchantEmail = {
        account: merchant.merchantAccount,
        merchantName: merchant.merchantName,
        createdBy: currentUser,
        dateCreated: dateCreated,
        email: merchant.merchant_contact_email,
        name: merchant.merchant_contact_name,
        type: "Merchant",
      };

      let outletEmail = {
        account: merchant.merchantAccount,
        merchantName: merchant.merchantName,
        createdBy: currentUser,
        dateCreated: dateCreated,
        email: merchant.merchant_outlet_contact_email,
        name: merchant.merchant_outlet_contact_name,
        outletId: merchant.merchant_outlet_outletId,
        outletName: merchant.merchant_outlet_name,
        type: "Outlet",
      };

      let merchantAPIKey = {
        account: merchantAccount,
        api_key: merchantAPIKeyRef.id,
        createdBy: currentUser,
        dateCreated: dateCreated,
        group: "Individual",
        isActive: true,
        merchant: newMerchant.name,
        merchantName: newMerchant.name,
        outletId: merchant.merchant_outlet_outletId,
        outletName: newMerchant.name,
        transactionLimit:
          merchant.merchantType === "Self-Service" ? 10000 : 5000,
        transactionMinimum: 1,
      };

      ////console.log("merchantAPIKey bitch", merchantAPIKey);

      let batch = firestore.batch();
      const regex = /^\d{4,}$/;
      if (regex.test(newMerchant.referralCode)) {
        let referralTransferRef = firestore.collection("transactions").doc();
        let referralTransferRefIn = firestore.collection("transactions").doc();

        await batch.set(referralTransferRef, referralTransfer);

        await batch.set(referralTransferRefIn, referralTransferIn);
      }
      // Add it in the batch
      await batch.set(newMerchantRef, newMerchant);

      // await batch.set(merchantEmailRef, merchantEmail);
      // await batch.set(outletEmailRef, outletEmail);

      await batch.set(merchantCommissionRef, merchantCommission);

      await batch.set(merchantBalanceRef, merchantBalance);
      await batch.set(merchantAPIKeyRef, merchantAPIKey);

      merchantProviders.forEach(async (provider) => {
        let providerRef = firestore.collection("providers").doc();

        await batch.set(providerRef, provider);
      });

      for (let i = 11; i <= 19; i++) {
        let id = `${outletId}-${i}`;
        let outletUserRef = firestore.collection("outlet_users").doc(id);
        let operator = createOutletUser(
          i,
          "Operator",
          merchantAccount,
          outletId,
          currentUser
        );

        await batch.set(outletUserRef, operator);
      }

      for (let i = 21; i <= 29; i++) {
        let id = `${outletId}-${i}`;
        let outletUserRef = firestore.collection("outlet_users").doc(id);
        let supervisor = createOutletUser(
          i,
          "Supervisor",
          merchantAccount,
          outletId,
          currentUser
        );

        await batch.set(outletUserRef, supervisor);
      }

      let id = `${outletId}-${31}`;
      let outletUserRef = firestore.collection("outlet_users").doc(id);
      let administrator = createOutletUser(
        31,
        "Administrator",
        merchantAccount,
        outletId,
        currentUser
      );

      await batch.set(outletUserRef, administrator);

      ////console.log("merchantCommission", merchantCommission);

      await batch.commit();
      // ////console.log("newMerchant", newMerchant);
      // let selfServiceCreationAccountStatus = await createSelfServiceAccount(
      //   newMerchant,
      //   merchantAPIKeyRef.id
      // );

      // let selfServiceCreationAccountAdminStatus =
      //   await createSelfServiceAccountAdmin(newMerchant, merchantAPIKeyRef.id);

      // const isSelfServiceAccountCreated =
      //   selfServiceCreationAccountStatus === "OK" ? "Created" : "Failed";
      // const isSelfServiceAccountAdminCreated =
      //   selfServiceCreationAccountAdminStatus === "OK" ? "Created" : "Failed";

      dispatch(closeModal());
      dispatch(fetchMerchants());
      dispatch(asyncActionFinish());

      toastr.success(`Success", "Merchant created `);

      // toastr.success(
      //   `Success", "Merchant created \n /n SelfService: ${isSelfServiceAccountCreated}, SelfService Account: ${isSelfServiceAccountAdminCreated}`
      // );
    } catch (error) {
      dispatch(asyncActionError());
      toastr.error("Oops", error.message || "Something went wrong");
    }
  };
};

export const createCorporateMerchant = (
  merchant,
  merchantAgreement,
  merchantOmang,
  merchantAffidavit,
  merchantHawkersLicense
) => {
  ////console.log("corporate", merchant);

  return async (dispatch, getState, { getFirebase, getFirestore }) => {
    dispatch(asyncActionStart());

    const firebase = getFirebase();
    const firestore = getFirestore();

    const currentUser = firebase.auth().currentUser.displayName;
    const currentUserBranch = getState().firebase.profile.branch;

    const dateCreated = new Date();
    /**
     * Generate ID
     */

    // 1 Generate MerchantAcc
    // let merchantAccount = await generateMerchantAccount(firestore);
    const merchantAccount = await createLuhnAccountNumber(8);

    // 2 Set the Id
    merchant.merchantAccount = merchantAccount;

    const outletId = `${merchantAccount}-01`;

    // 3 Add 01 to MerchantAcc to get OutletID
    merchant.merchant_outlet_outletId = outletId;

    let outlet = {
      city: merchant.merchant_outlet_city,
      name: merchant.merchant_outlet_name,
      id: merchant.merchant_outlet_outletId,
      suburb: merchant.merchant_outlet_suburb,
      type: merchant.merchant_outlet_type.value,
      dateCreated: dateCreated,
      createdBy: currentUser,
      contact: {
        email: merchant.merchant_outlet_contact_email,
        name: merchant.merchant_outlet_contact_name,
        telephone: merchant.merchant_outlet_contact_telephone,
      },
    };

    /**
     * END Generate ID
     */

    let newMerchant = createNewCorporateMerchant(
      merchant,
      currentUser,
      currentUserBranch
    );

    let merchantCommission = {
      account: merchantAccount,
      name: newMerchant.name,
      electricity: {
        bpc: {
          provider: "Botswana Power Corporation",
          rate: parseFloat(merchant.electricity_bpc),
          measurement: "Percentage",
        },
      },
      airtime: {
        beMobile: {
          provider: "beMobile",
          rate: parseFloat(merchant.airtime_bemobile),
          measurement: "Percentage",
        },
        mascom: {
          provider: "Mascom",
          rate: parseFloat(merchant.airtime_mascom),
          measurement: "Percentage",
        },
        orange: {
          provider: "Orange",
          rate: parseFloat(merchant.airtime_orange),
          measurement: "Percentage",
        },
      },
      // collections: {
      //   blil: {
      //     provider: "Botswana Life",
      //     rate: parseFloat(merchant.collections_botswanalife),
      //     measurement: "Fixed",
      //   },
      // },
      bills: {
        bpc: {
          provider: "Botswana Power Corporation",
          rate: parseFloat(merchant.bill_BPC),
          measurement: "Fixed",
        },
        dstv: {
          provider: "MultiChoice Botswana",
          rate: parseFloat(merchant.bill_DSTV),
          measurement: "Fixed",
        },
        wuc: {
          provider: "Water Utilities Corporation",
          rate: parseFloat(merchant.bill_WUC),
          measurement: "Fixed",
        },
        btc: {
          provider: "Botswana Telecommunications Corporation",
          rate: parseFloat(merchant.bill_BTCL),
          measurement: "Fixed",
        },
      },
      payments: {
        dstv: {
          provider: "MultiChoice Botswana",
          rate: parseFloat(merchant.bill_DSTV),
          measurement: "Percentage",
        },
        wuc: {
          provider: "Water Utilities Corporation",
          rate: 3,
          measurement: "Fixed",
        },
        gambling: {
          provider: "Gambling",
          rate: parseFloat(merchant.bill_Gambling),
          measurement: "Percentage",
        },
        botswanalife: {
          provider: "Botswana Life",
          rate: parseFloat(merchant.bill_BotswanaLife) || 0,
          measurement: "Percentage",
        },
        assurewealth: {
          provider: "Assure Wealth",
          rate: parseFloat(merchant.bill_AssureWealth) || 3.0,
          measurement: "Percentage",
        },
        myzakacashin: {
          measurement: "Of Vendor Commission",
          provider: "Myzaka cashin",
          rate: parseFloat(merchant.myzaka),
        },
        myzakacashout: {
          measurement: "Of Vendor Commission",
          provider: "Myzaka cashout",
          rate: parseFloat(merchant.myzaka),
        },
        badiphitlho: {
          provider: "Badiphitlho",
          rate: parseFloat(merchant.bill_Badiphitlho),
          measurement: "Percentage",
        }
      },
      schedule: merchant.commission_frequency.value,
      frequency: merchant.commission_frequency.value,
      isActive: true,
      dateCreated: dateCreated,
      createdBy: currentUser,
    };

    let merchantBalance = {
      account: merchantAccount,
      balance: 0,
      balanceBeforeTransaction: 0,
      dateCreated: dateCreated,
      createdBy: currentUser,
      isActiveBalance: true,
      transactionAmount: 0,
      transactionDateTime: dateCreated,
      transactionType: "Account Creation",
    };

    let merchantProviders = [
      {
        account: merchantAccount,
        type: "Airtime",
        provider: "Mascom-10",
        denomination: 10,
        name: newMerchant.name,
        isEnabled: false,
        dateCreated: dateCreated,
        createdBy: currentUser,
      },
      {
        account: merchantAccount,
        type: "Airtime",
        provider: "Mascom-20",
        denomination: 20,
        name: newMerchant.name,
        isEnabled: false,
        dateCreated: dateCreated,
        createdBy: currentUser,
      },
      {
        account: merchantAccount,
        type: "Airtime",
        provider: "Mascom-60",
        denomination: 60,
        name: newMerchant.name,
        isEnabled: false,
        dateCreated: dateCreated,
        createdBy: currentUser,
      },
      {
        account: merchantAccount,
        type: "Airtime",
        provider: "Mascom-100",
        denomination: 100,
        name: newMerchant.name,
        isEnabled: false,
        dateCreated: dateCreated,
        createdBy: currentUser,
      },
      {
        account: merchantAccount,
        type: "Airtime",
        provider: "Mascom Pinless",
        name: newMerchant.name,
        dateCreated: dateCreated,
        isEnabled: false,
        createdBy: currentUser,
        denomination: 0,
      },
      {
        account: merchantAccount,
        type: "Airtime",
        provider: "Orange Pinless",
        name: newMerchant.name,
        dateCreated: dateCreated,
        isEnabled: false,
        createdBy: currentUser,
        denomination: 0,
      },
      {
        account: merchantAccount,
        type: "Airtime",
        provider: "beMobile Pinless",
        name: newMerchant.name,
        dateCreated: dateCreated,
        isEnabled: false,
        createdBy: currentUser,
        denomination: 0,
      },
      {
        account: merchantAccount,
        type: "Airtime",
        provider: "Orange-10",
        denomination: 10,
        name: newMerchant.name,
        isEnabled: false,
        dateCreated: dateCreated,
        createdBy: currentUser,
      },
      {
        account: merchantAccount,
        type: "Airtime",
        provider: "Orange-20",
        denomination: 20,
        name: newMerchant.name,
        isEnabled: false,
        dateCreated: dateCreated,
        createdBy: currentUser,
      },
      {
        account: merchantAccount,
        type: "Airtime",
        provider: "Orange-50",
        denomination: 50,
        name: newMerchant.name,
        isEnabled: false,
        dateCreated: dateCreated,
        createdBy: currentUser,
      },
      {
        account: merchantAccount,
        type: "Airtime",
        provider: "Orange-100",
        denomination: 100,
        name: newMerchant.name,
        isEnabled: false,
        dateCreated: dateCreated,
        createdBy: currentUser,
      },
      {
        account: merchantAccount,
        type: "Airtime",
        provider: "Orange-250",
        denomination: 100,
        name: newMerchant.name,
        isEnabled: false,
        dateCreated: dateCreated,
        createdBy: currentUser,
      },
      {
        account: merchantAccount,
        type: "Airtime",
        provider: "Orange-500",
        denomination: 100,
        name: newMerchant.name,
        isEnabled: false,
        dateCreated: dateCreated,
        createdBy: currentUser,
      },
      {
        account: merchantAccount,
        type: "Airtime",
        provider: "beMobile-10",
        denomination: 10,
        name: newMerchant.name,
        isEnabled: false,
        dateCreated: dateCreated,
        createdBy: currentUser,
      },
      {
        account: merchantAccount,
        type: "Airtime",
        provider: "beMobile-20",
        denomination: 20,
        name: newMerchant.name,
        isEnabled: false,
        dateCreated: dateCreated,
        createdBy: currentUser,
      },
      {
        account: merchantAccount,
        type: "Airtime",
        provider: "beMobile-30",
        denomination: 30,
        name: newMerchant.name,
        isEnabled: false,
        dateCreated: dateCreated,
        createdBy: currentUser,
      },
      {
        account: merchantAccount,
        type: "Airtime",
        provider: "beMobile-50",
        denomination: 50,
        name: newMerchant.name,
        isEnabled: false,
        dateCreated: dateCreated,
        createdBy: currentUser,
      },
      {
        account: merchantAccount,
        type: "Airtime",
        provider: "beMobile-100",
        denomination: 100,
        name: newMerchant.name,
        isEnabled: false,
        dateCreated: dateCreated,
        createdBy: currentUser,
      },
      {
        account: merchantAccount,
        type: "Airtime",
        provider: "BTC",
        name: newMerchant.name,
        isEnabled: false,
        dateCreated: dateCreated,
        createdBy: currentUser,
      },
      {
        account: merchantAccount,
        type: "Electricity",
        provider: "BPC",
        name: newMerchant.name,
        isEnabled: true,
        dateCreated: dateCreated,
        createdBy: currentUser,
      },
      {
        account: merchantAccount,
        type: "Collections",
        provider: "BLIL",
        name: newMerchant.name,
        isEnabled: false,
        dateCreated: dateCreated,
        createdBy: currentUser,
      },
      {
        account: merchantAccount,
        type: "Bills",
        provider: "BTC",
        name: newMerchant.name,
        isEnabled: false,
        dateCreated: dateCreated,
        createdBy: currentUser,
      },
      {
        account: merchantAccount,
        type: "Bills",
        provider: "DSTV",
        name: newMerchant.name,
        isEnabled: false,
        dateCreated: dateCreated,
        createdBy: currentUser,
      },
      {
        account: merchantAccount,
        type: "Bills",
        provider: "WUC",
        name: newMerchant.name,
        isEnabled: false,
        dateCreated: dateCreated,
        createdBy: currentUser,
      },
      {
        account: merchantAccount,
        type: "Bills",
        provider: "BPC",
        name: newMerchant.name,
        isEnabled: false,
        dateCreated: dateCreated,
        createdBy: currentUser,
      },
      {
        account: merchantAccount,
        type: "Payments",
        provider: "MultiChoice Botswana",
        name: newMerchant.name,
        dateCreated: dateCreated,
        isEnabled: false,
        createdBy: currentUser,
        denomination: 0,
      },
      {
        account: merchantAccount,
        type: "Payments",
        provider: "Water Utilities Corporation",
        name: newMerchant.name,
        dateCreated: dateCreated,
        isEnabled: false,
        createdBy: currentUser,
        denomination: 0,
      },
      {
        type: "Payments",
        account: merchantAccount,
        name: newMerchant.name,
        provider: "Gambling",
        isEnabled: false,
        dateCreated: dateCreated,
        denomination: 0,
        createdBy: currentUser,
      },
      {
        type: "Payments",
        account: merchantAccount,
        name: newMerchant.name,
        provider: "Botswana Life",
        isEnabled: false,
        dateCreated: dateCreated,
        denomination: 0,
        createdBy: currentUser,
      },
      {
        type: "Payments",
        account: merchantAccount,
        name: newMerchant.name,
        provider: "Assure Wealth",
        isEnabled: false,
        dateCreated: dateCreated,
        denomination: 0,
        createdBy: currentUser,
      },
      {
        type: "Payments",
        account: merchantAccount,
        name: newMerchant.name,
        provider: "Myzaka cashout",
        isEnabled: false,
        dateCreated: dateCreated,
        denomination: 0,
        createdBy: currentUser,
      },
      {
        type: "Payments",
        account: merchantAccount,
        name: newMerchant.name,
        provider: "Myzaka cashin",
        isEnabled: false,
        dateCreated: dateCreated,
        denomination: 0,
        createdBy: currentUser,
      },
      {
        type: "Payments",
        account: merchantAccount,
        name: newMerchant.name,
        provider: "Badiphitlho",
        isEnabled: false,
        dateCreated: dateCreated,
        denomination: 0,
        createdBy: currentUser,
      },
    ];

    try {
      if (merchantAgreement) {
        await uploadMerchantAgreement(
          merchantAgreement,
          merchantAccount,
          firebase,
          dispatch
        );
      } else {
        throw new Error("Problem uploading merchant contract");
      }

      if (merchantOmang) {
        await uploadMerchantCipa(
          merchantOmang,
          merchantAccount,
          firebase,
          dispatch
        );
      } else {
        throw new Error("Problem uploading merchant contract");
      }

      if (merchantAffidavit) {
        await uploadMerchantOther(
          merchantAffidavit,
          merchantAccount,
          firebase,
          dispatch
        );
      }

      if (merchantHawkersLicense) {
        await uploadMerchantHawkersLicense(
          merchantHawkersLicense,
          merchantAccount,
          firebase,
          dispatch
        );
      }

      dispatch(asyncActionStart());

      // Create a ref with auto-generated ID
      let newMerchantRef = firestore
        .collection("merchants")
        .doc(merchantAccount);
      let merchantCommissionRef = firestore
        .collection("merchant_commission")
        .doc();
      let merchantEmailRef = firestore.collection("scheduleEmails").doc();
      let outletEmailRef = firestore.collection("scheduleEmails").doc();

      let merchantAPIKeyRef = firestore.collection("api_key").doc();

      newMerchantRef.collection("outlets").doc(outletId).set(outlet);

      let merchantBalanceRef = firestore.collection("merchant_balance").doc();

      newMerchant.id = newMerchantRef.id;
      merchantCommission.merchantId = newMerchantRef.id;
      merchantBalance.reference = merchantBalanceRef.id;

      let merchantEmail = {
        account: merchant.merchantAccount,
        merchantName: merchant.merchantName,
        createdBy: currentUser,
        dateCreated: dateCreated,
        email: merchant.merchant_contact_email,
        name: merchant.merchant_contact_name,
        type: "Merchant",
      };

      let outletEmail = {
        account: merchant.merchantAccount,
        merchantName: merchant.merchantName,
        createdBy: currentUser,
        dateCreated: dateCreated,
        email: merchant.merchant_outlet_contact_email,
        name: merchant.merchant_outlet_contact_name,
        outletId: merchant.merchant_outlet_outletId,
        outletName: merchant.merchant_outlet_name,
        type: "Outlet",
      };

      let merchantAPIKey = {
        account: merchantAccount,
        api_key: merchantAPIKeyRef.id,
        createdBy: currentUser,
        dateCreated: dateCreated,
        group: merchant.merchantGroup,
        isActive: true,
        merchant: newMerchant.name,
        merchantName: newMerchant.name,
        outletId: merchant.merchant_outlet_outletId,
        outletName: merchant.merchant_outlet_name,
        transactionLimit:
          merchant.merchantType === "Self-Service" ? 10000 : 5000,
        transactionMinimum: 1,
      };

      // let merchantAPIKey = {
      //   account: merchantAccount,
      //   api_key: merchantAPIKeyRef.id,
      //   createdBy: currentUser,
      //   dateCreated: dateCreated,
      //   group: merchant.merchantGroup,
      //   isActive: true,
      //   merchant: newMerchant.name,
      //   merchantName: newMerchant.name,
      //   outletId: merchant.merchant_outlet_outletId,
      //   outletName: newMerchant.name,
      //   transactionLimit:
      //     merchant.merchantType === "Self-Service" ? 10000 : 5000,
      //   transactionMinimum: 1,
      // };

      ////console.log("merchantAPIKey", merchantAPIKey);

      let batch = firestore.batch();

      // Add it in the batch
      await batch.set(newMerchantRef, newMerchant);

      await batch.set(merchantEmailRef, merchantEmail);
      await batch.set(outletEmailRef, outletEmail);

      await batch.set(merchantCommissionRef, merchantCommission);

      await batch.set(merchantBalanceRef, merchantBalance);
      await batch.set(merchantAPIKeyRef, merchantAPIKey);

      merchantProviders.forEach(async (provider) => {
        let providerRef = firestore.collection("providers").doc();

        await batch.set(providerRef, provider);
      });

      for (let i = 11; i <= 19; i++) {
        let id = `${outletId}-${i}`;
        let outletUserRef = firestore.collection("outlet_users").doc(id);
        let operator = createOutletUser(
          i,
          "Operator",
          merchantAccount,
          outletId,
          currentUser
        );

        await batch.set(outletUserRef, operator);
      }

      for (let i = 21; i <= 29; i++) {
        let id = `${outletId}-${i}`;
        let outletUserRef = firestore.collection("outlet_users").doc(id);
        let supervisor = createOutletUser(
          i,
          "Supervisor",
          merchantAccount,
          outletId,
          currentUser
        );

        await batch.set(outletUserRef, supervisor);
      }

      let id = `${outletId}-${31}`;
      let outletUserRef = firestore.collection("outlet_users").doc(id);
      let administrator = createOutletUser(
        31,
        "Administrator",
        merchantAccount,
        outletId,
        currentUser
      );

      await batch.set(outletUserRef, administrator);

      ////console.log("merchantCommission", merchantCommission);

      await batch.commit();
      // ////console.log("newMerchant", newMerchant);
      // let selfServiceCreationAccountStatus = await createSelfServiceAccount(
      //   newMerchant,
      //   merchantAPIKeyRef.id
      // );

      // let selfServiceCreationAccountAdminStatus =
      //   await createSelfServiceAccountAdmin(newMerchant, merchantAPIKeyRef.id);

      // const isSelfServiceAccountCreated =
      //   selfServiceCreationAccountStatus === "OK" ? "Created" : "Failed";
      // const isSelfServiceAccountAdminCreated =
      //   selfServiceCreationAccountAdminStatus === "OK" ? "Created" : "Failed";

      dispatch(closeModal());
      dispatch(fetchMerchants());
      dispatch(asyncActionFinish());

      toastr.success(`Success", "Merchant created `);

      // toastr.success(
      //   `Success", "Merchant created \n /n SelfService: ${isSelfServiceAccountCreated}, SelfService Account: ${isSelfServiceAccountAdminCreated}`
      // );
    } catch (error) {
      dispatch(asyncActionError());
      ////console.log("Oops", "Something went wrong", error);
      toastr.error("Oops", error.message || "Something went wrong");
    }
  };
};

// export const addSelfServiceAccount =
//   (merchant) => async (dispatch, getState) => {
//     const firestore = firebase.firestore();

//     const apiKeyRef = firestore
//       .collection("api_key")
//       .where("account", "==", merchant.account);

//     try {
//       dispatch(asyncActionStart());

//       const apiQuery = apiKeyRef;

//       let apiQuerySnap = await apiQuery.get();

//       if (apiQuerySnap.docs.length === 0) {
//         dispatch(asyncActionFinish());
//         return apiQuerySnap;
//       }

//       // const merchant = querySnap.docs[0].data();
//       const merchantApiKey = apiQuerySnap.docs[0].data();

//       //console.log("merchant", merchant);
//       //console.log("merchantApiKey", merchantApiKey);
//       // let selfServiceCreationAccountStatus,
//       //   selfServiceCreationAccountAdminStatus;

//       let selfServiceCreationAccountStatus = await createSelfServiceAccount(
//         merchant,
//         merchantApiKey.api_key
//       );

//       let selfServiceCreationAccountAdminStatus =
//         await createSelfServiceAccountAdmin(merchant, merchantApiKey.api_key);

//       const isSelfServiceAccountCreated =
//         selfServiceCreationAccountStatus === "OK" ? "Created" : "Failed";
//       const isSelfServiceAccountAdminCreated =
//         selfServiceCreationAccountAdminStatus === "OK" ? "Created" : "Failed";

//       // let batch = firestore.batch();

//       // await batch.set(newMerchantRef, newMerchant);

//       dispatch(asyncActionFinish());
//       toastr.success(
//         `Success", "Merchant created \n /n SelfService: ${isSelfServiceAccountCreated}, SelfService Account: ${isSelfServiceAccountAdminCreated}`
//       );
//     } catch (error) {
//       //console.log(error);
//       dispatch(asyncActionError());
//       toastr.error("Oops", "Something went wrong");
//     }
//   };

export const addSelfServiceAccount =
  (values, merchant) => async (dispatch, getState) => {
    const firestore = firebase.firestore();

    const apiKeyRef = firestore
      .collection("api_key")
      .where("account", "==", merchant.account);

    try {
      dispatch(asyncActionStart());

      const apiQuery = apiKeyRef;

      let apiQuerySnap = await apiQuery.get();

      if (apiQuerySnap.docs.length === 0) {
        dispatch(asyncActionFinish());
        dispatch(closeModal());
        toastr.error("Oops", "API Key not fount for merchant");
        return apiQuerySnap;
      }

      // const merchant = querySnap.docs[0].data();
      const merchantApiKey = apiQuerySnap.docs[0].data();

      //console.log("merchant", merchant);
      //console.log("merchantApiKey", merchantApiKey);
      // let selfServiceCreationAccountStatus,
      //   selfServiceCreationAccountAdminStatus;

      let outletId = `${merchant.account}-01`;

      let selfServiceCreationAccountStatus = await createSelfServiceAccount(
        merchant,
        merchantApiKey.api_key,
        outletId
      );

      let selfServiceCreationAccountAdminStatus =
        await createSelfServiceAccountAdmin(merchant, merchantApiKey.api_key);

      const isSelfServiceAccountCreated =
        selfServiceCreationAccountStatus === "OK" ? "Created" : "Failed";
      const isSelfServiceAccountAdminCreated =
        selfServiceCreationAccountAdminStatus === "OK" ? "Created" : "Failed";

      const bothCreated =
        isSelfServiceAccountCreated === "Created" &&
        isSelfServiceAccountAdminCreated === "Created";

      // Only mark Self Service active when both remote steps succeeded
      // ("Failed" is truthy, so do not check the status strings alone)
      if (bothCreated) {
        let merchantRef = await firestore
          .collection("merchants")
          .doc(merchant.account);

        let batch = firestore.batch();

        // Add it in the batch
        await batch.update(merchantRef, {
          hasSelfService: true,
        });

        await batch.commit();
      }

      // let batch = firestore.batch();

      // await batch.set(newMerchantRef, newMerchant);
      dispatch(closeModal());
      dispatch(asyncActionFinish());
      if (bothCreated) {
        toastr.success("Success", "Self-Service created successfully");
      } else {
        toastr.error(
          "Self-Service not created",
          `SelfService: ${isSelfServiceAccountCreated}, SelfService Account: ${isSelfServiceAccountAdminCreated}`
        );
      }
    } catch (error) {
      //console.log(error);
      dispatch(asyncActionError());
      dispatch(closeModal());
      toastr.error("Oops", "Something went wrong");
    }
  };

// export const addSelfServiceAccountToExisting =
//   async (merchant, values) => async (dispatch, getState) => {
//     const firestore = firebase.firestore();

//     let outlet = { values: values };
//     let adminContactName = values.merchant_outlet_contact_name;
//     let adminContactEmail = values.merchant_outlet_contact_email;
//     let adminContactNumber = values.merchant_outlet_contact_telephone;

//     // 3 Add 01 to MerchantAcc to get OutletID

//     const apiKeyRef = firestore
//       .collection("api_key")
//       .where("account", "==", merchant.account);

//     try {
//       dispatch(asyncActionStart());

//       const apiQuery = apiKeyRef;

//       let apiQuerySnap = await apiQuery.get();

//       if (apiQuerySnap.docs.length === 0) {
//         dispatch(asyncActionFinish());
//         return apiQuerySnap;
//       }

//       const merchantApiKey = apiQuerySnap.docs[0].data();

//       let outletId = await createSelfServiceOutlet(outlet, firestore);

//       let selfServiceCreationAccountStatus = await createSelfServiceAccount(
//         merchant,
//         merchantApiKey.api_key,
//         outletId
//       );

//       let selfServiceCreationAccountAdminStatus =
//         await createSelfServiceExistingAccountAdmin(
//           merchant,
//           merchantApiKey.api_key,
//           adminContactName,
//           adminContactEmail,
//           adminContactNumber
//         );

//       const isSelfServiceAccountCreated =
//         selfServiceCreationAccountStatus === "OK" ? "Created" : "Failed";
//       const isSelfServiceAccountAdminCreated =
//         selfServiceCreationAccountAdminStatus === "OK" ? "Created" : "Failed";

//       if (isSelfServiceAccountCreated) {
//         let merchantRef = await firestore
//           .collection("merchants")
//           .doc(merchant.account);

//         let batch = firestore.batch();

//         // Add it in the batch
//         await batch.update(merchantRef, {
//           hasSelfService: true,
//         });

//         await batch.commit();
//       }

//       dispatch(asyncActionFinish());
//       dispatch(closeModal());
//       toastr.success(
//         `Success", "Merchant created \n /n SelfService: ${isSelfServiceAccountCreated}, SelfService Account: ${isSelfServiceAccountAdminCreated}`
//       );
//     } catch (error) {
//       //console.log(error);
//       dispatch(asyncActionError());
//       toastr.error("Oops", "Something went wrong");
//     }
//   };

export const addSelfServiceAccountToExisting =
  (merchant, values) => async (dispatch, getState) => {
    const firestore = firebase.firestore();

    let outlet = { values: values };
    let adminContactName = values.merchant_outlet_contact_name;
    // Normalize so the same email with different casing cannot be reused
    let adminContactEmail = (values.merchant_outlet_contact_email || "")
      .trim()
      .toLowerCase();
    let adminContactNumber = values.merchant_outlet_contact_telephone;
    values.merchant_outlet_contact_email = adminContactEmail;

    // 3 Add 01 to MerchantAcc to get OutletID

    //console.log("addSelfServiceAccountToExisting", merchant, values);

    const apiKeyRef = firestore
      .collection("api_key")
      .where("account", "==", merchant.account);

    try {
      dispatch(asyncActionStart());

      let apiQuerySnap = await apiKeyRef.get();

      if (apiQuerySnap.docs.length === 0) {
        throw new Error("API key not found for this merchant");
      }

      const merchantApiKey = apiQuerySnap.docs[0].data();

      // Fail-all / pass-all:
      // 1) create Self-Service account remotely
      // 2) create Self-Service admin user remotely
      // 3) only then write the local outlet + hasSelfService flag
      // If step 1 or 2 fails, nothing local is created and we show an error.
      const outletId = await generateOutletId(merchant.account, firestore);

      await createSelfServiceAccount(
        merchant,
        merchantApiKey.api_key,
        outletId
      );

      await createSelfServiceExistingAccountAdmin(
        merchant,
        merchantApiKey.api_key,
        adminContactName,
        adminContactEmail,
        adminContactNumber
      );

      // Reuse the same outletId already sent to remote Self-Service.
      await createSelfServiceOutlet(outlet, firestore, outletId);

      await firestore.collection("merchants").doc(merchant.account).update({
        hasSelfService: true,
      });

      dispatch(asyncActionFinish());
      dispatch(closeModal());
      toastr.success("Success", "Self-Service outlet created successfully");
    } catch (error) {
      // Fail-all: surface the real API/validation message (e.g. email already in use)
      dispatch(asyncActionError());
      toastr.error(
        "Self-Service outlet not created",
        (error && error.message) || "Something went wrong"
      );
      throw new SubmissionError({
        _error: (error && error.message) || "Something went wrong",
      });
    }
  };

const createSelfServiceAccount = async (merchant, apiKey, outletId) => {
  try {
    const url =
      "https://us-central1-prod-self-service.cloudfunctions.net/api/v1/account/add-account";
    const response = await axios.post(url, {
      name: merchant.name,
      accountNumber: +merchant.account,
      outletId: outletId,
      apiKey: apiKey,
      phoneNumber: merchant.contact.telephone,
      postalAddress: merchant.suburb,
      city: merchant.city,
      createdBy: "admin@prepaidplus.co.bw",
    });

    return response.data;
  } catch (error) {
    // Account may already exist from a previous partial attempt — safe to continue
    if (error && error.response && error.response.status === 409) {
      return "OK";
    }
    const message =
      (error &&
        error.response &&
        error.response.data &&
        error.response.data.message) ||
      (error && error.message) ||
      "Failed to create Self-Service account";
    throw new Error(message);
  }
};



  //   Object
  // config: {transformRequest: {…}, transformResponse: {…}, timeout: 0, xsrfCookieName: 'XSRF-TOKEN', adapter: ƒ, …}
  // data: "OK"
  // headers: {cache-control: 'private', content-length: '22', content-type: 'text/plain; charset=utf-8'}
  // request: XMLHttpRequest {readyState: 4, timeout: 0, withCredentials: false, upload: XMLHttpRequestUpload, onreadystatechange: ƒ, …}
  // status: 200
  // statusText: ""
  // [[Prototype]]: Object
const createSelfServiceAccountAdmin = async (merchant, apiKey) => {
  const contactNamesArray = merchant.contact.name.split(" ");
  const contactFirstName = contactNamesArray[0];
  const contactLastName =
    contactNamesArray.length > 1
      ? contactNamesArray[1] !== ""
        ? contactNamesArray[1]
        : contactNamesArray[0]
      : contactNamesArray[0];

  try {
    const url =
      "https://us-central1-prod-self-service.cloudfunctions.net/api/v1/users/create";
    return await axios
      .post(url, {
        firstName: contactFirstName,
        lastName: contactLastName,
        role: "Administrator",
        email: merchant.contact.email,
        apiKey: apiKey,
        password: "p@ssword",
        contactNumber: merchant.contact.telephone,
        account: +merchant.account,
        accountName: merchant.name,
        createdBy: "admin@prepaidplus.co.bw",
      })
      .then((response) => {
        return response.data;
      });
  } catch (error) {
    return error;
  }
};



  //   Object
  // config: {transformRequest: {…}, transformResponse: {…}, timeout: 0, xsrfCookieName: 'XSRF-TOKEN', adapter: ƒ, …}
  // data: "OK"
  // headers: {cache-control: 'private', content-length: '22', content-type: 'text/plain; charset=utf-8'}
  // request: XMLHttpRequest {readyState: 4, timeout: 0, withCredentials: false, upload: XMLHttpRequestUpload, onreadystatechange: ƒ, …}
  // status: 200
  // statusText: ""
  // [[Prototype]]: Object
const createSelfServiceExistingAccountAdmin = async (
  merchant,
  apiKey,
  adminContactName,
  adminContactEmail,
  adminContactNumber
) => {
  //console.log(
  //   "adminContactName",
  //   adminContactName,
  //   adminContactEmail,
  //   adminContactNumber
  // );

  const contactNamesArray = adminContactName.split(" ");
  const contactFirstName = contactNamesArray[0];
  const contactLastName =
    contactNamesArray.length > 1 ? contactNamesArray[1] : " ";

  try {
    const url =
      "https://us-central1-prod-self-service.cloudfunctions.net/api/v1/users/create";
    const response = await axios.post(url, {
      firstName: contactFirstName,
      lastName: contactLastName,
      role: "Administrator",
      apiKey: apiKey,
      email: adminContactEmail,
      password: "p@ssword",
      contactNumber: adminContactNumber,
      account: +merchant.account,
      accountName: merchant.name,
      createdBy: "admin@prepaidplus.co.bw",
    });

    return response.data;
  } catch (error) {
    // Includes duplicate-email 409 from Self-Service API — must throw so portal fails all
    const message =
      (error &&
        error.response &&
        error.response.data &&
        error.response.data.message) ||
      (error && error.message) ||
      "Failed to create Self-Service administrator";
    throw new Error(message);
  }
};



  //   Object
  // config: {transformRequest: {…}, transformResponse: {…}, timeout: 0, xsrfCookieName: 'XSRF-TOKEN', adapter: ƒ, …}
  // data: "OK"
  // headers: {cache-control: 'private', content-length: '22', content-type: 'text/plain; charset=utf-8'}
  // request: XMLHttpRequest {readyState: 4, timeout: 0, withCredentials: false, upload: XMLHttpRequestUpload, onreadystatechange: ƒ, …}
  // status: 200
  // statusText: ""
  // [[Prototype]]: Object
export const updateMerchant = (merchant) => {
  return {
    type: UPDATE_MERCHANT,
    payload: {
      merchant,
    },
  };
};

export const deleteMerchant = (merchantId) => {
  return {
    type: DELETE_MERCHANT,
    payload: {
      merchantId,
    },
  };
};

const uploadMerchantDocument = async (
  file,
  merchantAccount,
  firebase,
  dispatch,
  docType,
  errorMessage,
  optional = false
) => {
  if (!file) {
    if (optional) return null;
    throw new Error(errorMessage);
  }

  try {
    await validateMerchantPdfFile(file, docType, { required: true });
  } catch (validationError) {
    throw new Error(validationError.message || errorMessage);
  }

  const filePath = `${merchantAccount}/${merchantAccount}-${docType}.pdf`;

  try {
    dispatch(asyncActionStart());
    const storageRef = firebase.storage().ref();
    const fileRef = storageRef.child(filePath);
    const uploadResult = await fileRef.put(file);
    dispatch(asyncActionFinish());
    return uploadResult;
  } catch (error) {
    dispatch(asyncActionError());
    throw new Error(errorMessage);
  }
};

export const uploadMerchantAgreement = async (
  file,
  merchantAccount,
  firebase,
  dispatch
) =>
  uploadMerchantDocument(
    file,
    merchantAccount,
    firebase,
    dispatch,
    "Contract",
    "Problem uploading merchant contract"
  );

export const uploadMerchantOmang = async (
  file,
  merchantAccount,
  firebase,
  dispatch
) =>
  uploadMerchantDocument(
    file,
    merchantAccount,
    firebase,
    dispatch,
    "Omang",
    "Problem uploading merchant omang"
  );

export const uploadMerchantCipa = async (
  file,
  merchantAccount,
  firebase,
  dispatch
) =>
  uploadMerchantDocument(
    file,
    merchantAccount,
    firebase,
    dispatch,
    "Cipa",
    "Problem uploading merchant cipa"
  );

export const uploadMerchantAffidavit = async (
  file,
  merchantAccount,
  firebase,
  dispatch
) =>
  uploadMerchantDocument(
    file,
    merchantAccount,
    firebase,
    dispatch,
    "Affidavit",
    "Problem uploading merchant affidavit"
  );

export const uploadMerchantOther = async (
  file,
  merchantAccount,
  firebase,
  dispatch
) =>
  uploadMerchantDocument(
    file,
    merchantAccount,
    firebase,
    dispatch,
    "Other",
    "Problem uploading merchant other document",
    true
  );

export const uploadMerchantHawkersLicense = async (
  file,
  merchantAccount,
  firebase,
  dispatch
) =>
  uploadMerchantDocument(
    file,
    merchantAccount,
    firebase,
    dispatch,
    "HawkersLicense",
    "Problem uploading hawkers license",
    true
  );

/**
 * Fetches all districts from Firestore.
 * @returns {Array} returns an array of district objects.
 */
export const fetchDistricts = async () => {
  const firestore = firebase.firestore();
  const districtsRef = firestore.collection("botswana_districts");

  try {
    const querySnap = await districtsRef.get();
    let districts = [];

    querySnap.forEach((doc) => {
      districts.push({ id: doc.id, ...doc.data() });
    });

    return districts;
  } catch (error) {
    return [];
  }
};

/**
 * Maps a given city to its corresponding district.
 * @param {Array} districtsCollection - Array of district objects retrieved from Firestore.
 * @param {string} city - The city name to look up from merchant.
 * @returns {string} The corresponding district name or "Other District" if not found.
 */
function getDistrictForCity(districtsCollection, city) {
  let cityToDistrictMap = {};

  districtsCollection.forEach((districtDoc) => {
    const districtName = districtDoc.district;
    const places = districtDoc.places;

    Object.values(places).forEach((place) => {
      cityToDistrictMap[
        place
          .toLowerCase()
          .trim()
          .replace(/\b\w/g, (char) => char.toUpperCase())
      ] = districtName;
    });
  });

  return cityToDistrictMap[city] || "Other District";
}

export const fetchMerchants = () => async (dispatch, getState) => {
  const firestore = firebase.firestore();

  if (!getState().firebase.profile.isEmpty) {
    const loggedInUser = getState().firebase.profile;

    let merchantsRef;

    //console.log("loggedInUser", loggedInUser);
    if (loggedInUser.account === "PrepaidPlus") {
      merchantsRef = firestore.collection("merchants");
    } else {
      if (loggedInUser.role === "Group Administrator") {
        merchantsRef = firestore
          .collection("merchants")
          .where("group", "==", loggedInUser.group);
      } else {
        merchantsRef = firestore
          .collection("merchants")
          .where("account", "==", loggedInUser.account);
      }
    }

    // const merchantsRef = firestore.collection("merchants").where("account", "in", ["3416"]);;
    try {
      dispatch(asyncActionStart());

      let query;
      query = merchantsRef.orderBy("name").limit(50);

      let querySnap = await query.get();

      if (querySnap.docs.length === 0) {
        dispatch(asyncActionFinish());
        return querySnap;
      }

      // Fetch districts
      let districtsCollection = await fetchDistricts();

      let merchants = [];

      for (let i = 0; i < querySnap.docs.length; i++) {
        let merchant = {
          ...querySnap.docs[i].data(),
          id: querySnap.docs[i].id,
        };
        merchant.city = (merchant.city || "")
          .toString()
          .trim()
          .toLowerCase()
          .replace(/\b\w/g, (char) => char.toUpperCase());

        // Assign district to the merchant
        merchant.district = getDistrictForCity(
          districtsCollection,
          merchant.city
        );
        //let newcity = merchant.city.trim();

        merchants.push(merchant);
      }

      dispatch({ type: FETCH_MERCHANTS, payload: { merchants } });
      dispatch(asyncActionFinish());
    } catch (error) {
      //console.log(error);
      dispatch(asyncActionError());
    }
  }
};

export const clearMerchants = () => async (dispatch) => {
  try {
    dispatch(asyncActionStart());

    let merchants = [];

    dispatch({ type: FETCH_MERCHANTS, payload: { merchants } });
    dispatch(asyncActionFinish());
  } catch (error) {
    //console.log(error);
    dispatch(asyncActionError());
  }
};

export const createOutletAction = (outlet) => {
  return async (dispatch, getState, { getFirebase, getFirestore }) => {
    dispatch(asyncActionStart());
    const firebase = getFirebase();
    const firestore = getFirestore();
    const currentUser = firebase.auth().currentUser.displayName;
    const dateCreated = new Date();

    let merchantAccount = outlet.values.merchantId;

    //console.log("merchantUid", merchantAccount);

    /**
     * Generate ID
     */
    let outletId = await generateOutletId(merchantAccount, firestore);

    /**
     * END Generate ID
     */
    outlet.values.merchant_outlet_outletId = outletId;
    let newOutlet = createNewOutlet(outlet, currentUser);
    let outletEmailRef = firestore.collection("scheduleEmails").doc();

    try {
      let outletRef = firestore
        .collection("merchants")
        .doc(merchantAccount)
        .collection("outlets")
        .doc(outletId);

      let outletEmail = {
        account: merchantAccount,
        merchantName: outlet.values.merchantName,
        createdBy: currentUser,
        dateCreated: dateCreated,
        email: outlet.values.merchant_outlet_contact_email,
        name: outlet.values.merchant_outlet_contact_name,
        outletId: outletId,
        outletName: outlet.values.merchant_outlet_name,
        type: "Outlet",
      };

      //console.log("outletEmail", outletEmail);

      let batch = firestore.batch();

      // Add it in the batch
      await batch.set(outletRef, newOutlet);

      await batch.set(outletEmailRef, outletEmail);

      for (let i = 11; i <= 19; i++) {
        let id = `${outletId}-${i}`;
        let outletUserRef = firestore.collection("outlet_users").doc(id);
        let operator = createOutletUser(
          i,
          "Operator",
          merchantAccount,
          outletId,
          currentUser
        );

        await batch.set(outletUserRef, operator);
      }

      for (let i = 21; i <= 29; i++) {
        let id = `${outletId}-${i}`;
        let outletUserRef = firestore.collection("outlet_users").doc(id);
        let supervisor = createOutletUser(
          i,
          "Supervisor",
          merchantAccount,
          outletId,
          currentUser
        );

        await batch.set(outletUserRef, supervisor);
      }

      let id = `${outletId}-${31}`;
      let outletUserRef = firestore.collection("outlet_users").doc(id);
      let administrator = createOutletUser(
        31,
        "Administrator",
        merchantAccount,
        outletId,
        currentUser
      );

      await batch.set(outletUserRef, administrator);

      await batch.commit();

      dispatch(closeModal());
      dispatch(asyncActionFinish());
      toastr.success("Success", "Outlet has been created");
    } catch (error) {
      dispatch(asyncActionError());
      toastr.error("Oops", "Something went wrong");

      throw new SubmissionError({
        _error: error.message,
      });
    }
  };
};

export const createSelfServiceOutlet = async (
  outlet,
  firestore,
  existingOutletId
) => {
  // return async (dispatch, getState, { getFirebase, getFirestore }) => {
  // dispatch(asyncActionStart());
  // const firebase = getFirebase();
  // const firestore = getFirestore();
  const currentUser = firebase.auth().currentUser.displayName;
  const dateCreated = new Date();

  let merchantAccount = outlet.values.merchantId;

  //console.log("merchantUid", merchantAccount);

  // Prefer the outletId already used for remote Self-Service account create
  // so local Firestore and remote stay aligned.
  let outletId =
    existingOutletId || (await generateOutletId(merchantAccount, firestore));

  outlet.values.merchant_outlet_outletId = outletId;
  let newOutlet = createNewOutlet(outlet, currentUser);
  let outletEmailRef = firestore.collection("scheduleEmails").doc();

  try {
    let outletRef = firestore
      .collection("merchants")
      .doc(merchantAccount)
      .collection("outlets")
      .doc(outletId);

    let outletEmail = {
      account: merchantAccount,
      merchantName: outlet.values.merchantName,
      createdBy: currentUser,
      dateCreated: dateCreated,
      email: outlet.values.merchant_outlet_contact_email,
      name: outlet.values.merchant_outlet_contact_name,
      outletId: outletId,
      outletName: outlet.values.merchant_outlet_name,
      type: "Outlet",
    };

    //console.log("outletEmail", outletEmail);

    let batch = firestore.batch();

    // Add it in the batch
    await batch.set(outletRef, newOutlet);

    await batch.set(outletEmailRef, outletEmail);

    for (let i = 11; i <= 19; i++) {
      let id = `${outletId}-${i}`;
      let outletUserRef = firestore.collection("outlet_users").doc(id);
      let operator = createOutletUser(
        i,
        "Operator",
        merchantAccount,
        outletId,
        currentUser
      );

      await batch.set(outletUserRef, operator);
    }

    for (let i = 21; i <= 29; i++) {
      let id = `${outletId}-${i}`;
      let outletUserRef = firestore.collection("outlet_users").doc(id);
      let supervisor = createOutletUser(
        i,
        "Supervisor",
        merchantAccount,
        outletId,
        currentUser
      );

      await batch.set(outletUserRef, supervisor);
    }

    let id = `${outletId}-${31}`;
    let outletUserRef = firestore.collection("outlet_users").doc(id);
    let administrator = createOutletUser(
      31,
      "Administrator",
      merchantAccount,
      outletId,
      currentUser
    );

    await batch.set(outletUserRef, administrator);

    await batch.commit();

    return outletId;

    // dispatch(closeModal());
    // dispatch(asyncActionFinish());
    // toastr.success("Success", "Outlet has been created");
  } catch (error) {
    // dispatch(asyncActionError());
    // toastr.error("Oops", "Something went wrong");

    throw new SubmissionError({
      _error: error.message,
    });
  }
};

export const activateMerchant = (account) => {
  return async (dispatch, getState, { getFirebase, getFirestore }) => {
    const firebase = getFirebase();
    const firestore = getFirestore();
    const currentUser = firebase.auth().currentUser.displayName;

    //console.log("In activate account", account);

    const now = new Date();

    try {
      dispatch(asyncActionStart());
      await firestore.collection("merchants").doc(account).set(
        {
          isMerchantActive: true,
          enabledBy: currentUser,
          dateEnabled: now,
        },
        { merge: true }
      );

      dispatch(closeModal());
      dispatch(asyncActionFinish());
      toastr.success("Success", "Merchant has been enabled");
    } catch (error) {
      dispatch(asyncActionError());
      toastr.error("Oops", "Something went wrong");
    }
  };
};

export const activateDevice = (deviceId) => {
  return async (dispatch, getState, { getFirebase, getFirestore }) => {
    const firebase = getFirebase();
    const firestore = getFirestore();
    const currentUser = firebase.auth().currentUser.displayName;

    const now = new Date();

    try {
      dispatch(asyncActionStart());

      await firestore.collection("outlet_inventory").doc(deviceId).set(
        {
          isActivated: true,
          activatedBy: currentUser,
          dateActivated: now,
        },
        { merge: true }
      );

      dispatch(closeModal());
      dispatch(asyncActionFinish());

      toastr.success("Success", "Device has been activated");
    } catch (error) {
      dispatch(asyncActionError());
      toastr.error("Oops", "Something went wrong");
    }
  };
};

export const deactivateDevice = (deviceId) => {
  return async (dispatch, getState, { getFirebase, getFirestore }) => {
    const firebase = getFirebase();
    const firestore = getFirestore();
    const currentUser = firebase.auth().currentUser.displayName;

    const now = new Date();

    try {
      dispatch(asyncActionStart());
      await firestore.collection("outlet_inventory").doc(deviceId).set(
        {
          isActivated: false,
          activatedBy: currentUser,
          dateActivated: now,
        },
        { merge: true }
      );

      dispatch(closeModal());
      dispatch(asyncActionFinish());
      toastr.success("Success", "Device has been disabled");
    } catch (error) {
      dispatch(asyncActionError());
      toastr.error("Oops", "Something went wrong");
    }
  };
};

export const unassignDeviceFromMerchant = (
  inventoryId,
  outletInventoryId,
  cellNumber
) => {
  return async (dispatch, getState, { getFirebase, getFirestore }) => {
    const firebase = getFirebase();
    const firestore = getFirestore();
    const currentUser = firebase.auth().currentUser.displayName;

    const now = new Date();

    try {
      dispatch(asyncActionStart());
      let cellphoneInventoryId = await firestore
        .collection("inventory")
        .where("cellNumber", "==", cellNumber)
        .get()
        .then((querySnapshot) => {
          //console.log("querySnapshot.docs[0].id", querySnapshot.docs[0].id);
          return querySnapshot.docs[0].id;

          // return querySnapshot.docs.map(doc => {
          //   return doc.id;
          // });
        });

      //console.log("cellphoneInventoryId", cellphoneInventoryId);

      let cellphoneInventoryRef = await firestore
        .collection("inventory")
        .doc(cellphoneInventoryId);

      let outletInventoryRef = await firestore
        .collection("outlet_inventory")
        .doc(outletInventoryId);

      let inventoryRef = await firestore
        .collection("inventory")
        .doc(inventoryId);

      let batch = firestore.batch();

      // Add it in the batch
      await batch.update(inventoryRef, {
        allocatedTo: firebase.firestore.FieldValue.delete(),
      });
      await batch.update(inventoryRef, {
        dateAllocated: firebase.firestore.FieldValue.delete(),
      });
      await batch.update(inventoryRef, { isAllocated: false });

      await batch.update(cellphoneInventoryRef, {
        allocatedTo: firebase.firestore.FieldValue.delete(),
      });
      await batch.update(cellphoneInventoryRef, {
        dateAllocated: firebase.firestore.FieldValue.delete(),
      });
      await batch.update(cellphoneInventoryRef, { isAllocated: false });

      await batch.delete(outletInventoryRef);

      await batch.commit();
      dispatch(asyncActionFinish());
      toastr.success("Success", "Device has been unlinked from outlet");
    } catch (error) {
      dispatch(asyncActionError());
      toastr.error("Oops", "Something went wrong");
    }
  };
};

// var cityRef = db.collection('cities').doc('BJ');

// // Remove the 'capital' field from the document
// var removeCapital = cityRef.update({
//     capital: firebase.firestore.FieldValue.delete()
// });

// db.collection("cities").doc("DC").delete().then(function() {
//   //console.log("Document successfully deleted!");
// }).catch(function(error) {
//   //console.error("Error removing document: ", error);
// });

export const enableOutletUser = (values, userId, account) => {
  return async (dispatch, getState, { getFirebase, getFirestore }) => {
    const firebase = getFirebase();
    const firestore = getFirestore();
    const currentUser = firebase.auth().currentUser.displayName;

    const now = new Date();

    try {
      dispatch(asyncActionStart());
      let createdOutlet = await firestore
        .collection("outlet_users")
        .doc(userId)
        .set(
          {
            account: account,
            isUserEnabled: true,
            updatedBy: currentUser,
            dateUpdated: now,
            password: hashPassword(values.password),
          },
          { merge: true }
        );

      dispatch(closeModal());
      dispatch(asyncActionFinish());
      toastr.success("Success", "User has been enabled");
    } catch (error) {
      dispatch(asyncActionError());
      toastr.error("Oops", "Something went wrong");
    }
  };
};

export const disableOutletUser = (values, userId) => {
  return async (dispatch, getState, { getFirebase, getFirestore }) => {
    const firebase = getFirebase();
    const firestore = getFirestore();
    const currentUser = firebase.auth().currentUser.displayName;

    const now = new Date();

    try {
      dispatch(asyncActionStart());
      await firestore.collection("outlet_users").doc(userId).set(
        {
          isUserEnabled: false,
          updatedBy: currentUser,
          dateUpdated: now,
        },
        { merge: true }
      );

      dispatch(closeModal());
      dispatch(asyncActionFinish());
      toastr.success("Success", "User has been disabled");
    } catch (error) {
      dispatch(asyncActionError());
      toastr.error("Oops", "Something went wrong");
    }
  };
};

export const updateMerchantField = (values, account, type) => {
  return async (dispatch, getState, { getFirebase, getFirestore }) => {
    const firebase = getFirebase();
    const firestore = getFirestore();
    const currentUser = firebase.auth().currentUser.displayName;

    const now = new Date();

    try {
      dispatch(asyncActionStart());
      switch (type) {
        case "Name":
          await firestore.collection("merchants").doc(account).set(
            {
              name: values.merchantName,
              updatedBy: currentUser,
              dateUpdated: now,
            },
            { merge: true }
          );
          break;
        case "Group":
          await firestore.collection("merchants").doc(account).set(
            {
              group: values.merchantGroup,
              updatedBy: currentUser,
              dateUpdated: now,
            },
            { merge: true }
          );
          break;
        case "Contact":
          let contact = {
            name: values.merchant_contact_name,
            email: values.merchant_contact_email,
            telephone: values.merchant_contact_telephone,
          };
          await firestore.collection("merchants").doc(account).set(
            {
              contact,
              updatedBy: currentUser,
              dateUpdated: now,
            },
            { merge: true }
          );
          break;
        case "Location":
          await firestore.collection("merchants").doc(account).set(
            {
              city: values.merchantCity,
              suburb: values.merchantSuburb,
              updatedBy: currentUser,
              dateUpdated: now,
            },
            { merge: true }
          );
          break;
        case "SellerDetails":
          await firestore.collection("merchants").doc(account).set(
            {
              sellerId: values.merchantSellerId.value,
              updatedBy: currentUser,
              dateUpdated: now,
            },
            { merge: true }
          );
          break;
        case "MerchantType":
          await firestore.collection("merchants").doc(account).set(
            {
              merchantType: values.merchantType.value,
              updatedBy: currentUser,
              dateUpdated: now,
            },
            { merge: true }
          );
          break;
        case "Status":
          await firestore
            .collection("merchants")
            .doc(account)
            .set(
              {
                isMerchantActive: values.status ? false : true,
                updatedBy: currentUser,
                dateUpdated: now,
              },
              { merge: true }
            );
          break;
        default:
          return null;
      }
      dispatch(closeModal());
      dispatch(asyncActionFinish());
      toastr.success("Success", "Field has been update");
    } catch (error) {
      dispatch(asyncActionError());
      toastr.error("Oops", "Something went wrong");
    }
  };
};

export const updateOutletField = (values, account, outletId, type) => {
  return async (dispatch, getState, { getFirebase, getFirestore }) => {
    const firebase = getFirebase();
    const firestore = getFirestore();
    const currentUser = firebase.auth().currentUser.displayName;

    //console.log("account", account);
    //console.log("outletId", outletId);
    //console.log("type", type);

    const now = new Date();

    try {
      dispatch(asyncActionStart());
      switch (type) {
        case "Name":
          await firestore
            .collection("merchants")
            .doc(account)
            .collection("outlets")
            .doc(outletId)
            .set(
              {
                name: values.outletName,
                updatedBy: currentUser,
                dateUpdated: now,
              },
              { merge: true }
            );
          break;
        case "Contact":
          let updatedContect = {
            name: values.outlet_contact_name,
            email: values.outlet_contact_email,
            telephone: values.outlet_contact_telephone,
          };

          await firestore
            .collection("merchants")
            .doc(account)
            .collection("outlets")
            .doc(outletId)
            .set(
              {
                contact: updatedContect,
                updatedBy: currentUser,
                dateUpdated: now,
              },
              { merge: true }
            );
          break;
        case "Location":
          await firestore
            .collection("merchants")
            .doc(account)
            .collection("outlets")
            .doc(outletId)
            .set(
              {
                city: values.outletCity,
                suburb: values.outletSuburb,
                updatedBy: currentUser,
                dateUpdated: now,
              },
              { merge: true }
            );
          break;
        case "OutletType":
          await firestore
            .collection("merchants")
            .doc(account)
            .collection("outlets")
            .doc(outletId)
            .set(
              {
                type: values.outletType.value,
                updatedBy: currentUser,
                dateUpdated: now,
              },
              { merge: true }
            );
          break;
        default:
          return null;
      }
      dispatch(closeModal());
      dispatch(asyncActionFinish());
      toastr.success("Success", "Field has been update");
    } catch (error) {
      dispatch(asyncActionError());
      toastr.error("Oops", "Something went wrong");
    }
  };
};

export const updateUserPassword = (values, userId) => {
  return async (dispatch, getState, { getFirebase, getFirestore }) => {
    const firebase = getFirebase();
    const firestore = getFirestore();
    const currentUser = firebase.auth().currentUser.displayName;

    const now = new Date();

    try {
      dispatch(asyncActionStart());
      await firestore
        .collection("outlet_users")
        .doc(userId)
        .set(
          {
            isUserEnabled: true,
            updatedBy: currentUser,
            dateUpdated: now,
            password: hashPassword(values.password),
          },
          { merge: true }
        );

      dispatch(closeModal());
      dispatch(asyncActionFinish());
      toastr.success("Success", "User password has been update");
    } catch (error) {
      dispatch(asyncActionError());
      toastr.error("Oops", "Something went wrong");
    }
  };
};

export const updateUserName = (values, userId) => {
  return async (dispatch, getState, { getFirebase, getFirestore }) => {
    const firebase = getFirebase();
    const firestore = getFirestore();
    const currentUser = firebase.auth().currentUser.displayName;

    const now = new Date();

    try {
      dispatch(asyncActionStart());
      await firestore.collection("outlet_users").doc(userId).set(
        {
          updatedBy: currentUser,
          dateUpdated: now,
          name: values.name,
        },
        { merge: true }
      );

      dispatch(closeModal());
      dispatch(asyncActionFinish());
      toastr.success("Success", "User name has been updated");
    } catch (error) {
      dispatch(asyncActionError());
      toastr.error("Oops", "Something went wrong");
    }
  };
};

export const generatePairingCode = (merchantName, outletName, device) => {
  return async (dispatch, getState, { getFirebase, getFirestore }) => {
    const firebase = getFirebase();
    const firestore = getFirestore();
    const currentUser = firebase.auth().currentUser.displayName;
    let account = device.account;
    /**
     * Generate ID
     */
    let pairingCode = createRandomPairingCode(8);
    /**
     * END Generate ID
     */
    const now = new Date();
    //console.log("device", device);

    let pairingObject = {
      registrationId: device.id,
      account: device.account,
      deviceType: device.deviceType ? device.deviceType : "Device",
      deviceNetworkType: device.deviceNetworkType,
      macAddress: device.macAddress,
      outletId: device.outletId,
      outletName: outletName,
      merchantName: merchantName,
      pairingCode: pairingCode,
      isActive: false,
      reportsUser: "41",
      reportsUserPassword: hashPassword("1234"),
      dateCreated: now,
      createdBy: currentUser,
    };

    //console.log("paringObject", pairingObject);
    //console.log("device", device);
    try {
      dispatch(asyncActionStart());
      await firestore
        .collection("inventory_pairing")
        .doc(pairingCode)
        .set(pairingObject);
      dispatch(asyncActionFinish());
      toastr.success("Success", "Pairing code has been created");
    } catch (error) {
      dispatch(asyncActionError());
      toastr.error("Oops", "Something went wrong");
    }
  };
};

export const updatePairingCode = (
  merchantName,
  outletName,
  device,
  oldPairingCode
) => {
  return async (dispatch, getState, { getFirebase, getFirestore }) => {
    const firebase = getFirebase();
    const firestore = getFirestore();
    const currentUser = firebase.auth().currentUser.displayName;
    let account = device.account;
    /**
     * Generate ID
     */
    let pairingCode = createRandomPairingCode(8);
    /**
     * END Generate ID
     */
    const now = new Date();
    //console.log("device", device);

    let pairingObject = {
      registrationId: device.id,
      account: device.account,
      deviceType: device.deviceType ? device.deviceType : "Device",
      deviceNetworkType: device.deviceNetworkType,
      macAddress: device.macAddress,
      outletId: device.outletId,
      outletName: outletName,
      merchantName: merchantName,
      pairingCode: pairingCode,
      isActive: false,
      reportsUser: "41",
      reportsUserPassword: hashPassword("1234"),
      dateCreated: now,
      createdBy: currentUser,
    };

    //console.log("paringObject", pairingObject);
    //console.log("device", device);
    try {
      dispatch(asyncActionStart());

      let oldPairingCodeRef = firestore
        .collection("inventory_pairing")
        .doc(oldPairingCode);

      let newPairingCodeRef = firestore
        .collection("inventory_pairing")
        .doc(pairingObject.pairingCode);

      let batch = firestore.batch();

      await batch.delete(oldPairingCodeRef);

      await batch.set(newPairingCodeRef, pairingObject);

      await batch.commit();

      // await firestore
      //   .collection("inventory_pairing")
      //   .doc(pairingCode)
      //   .set(pairingObject);
      dispatch(asyncActionFinish());
      toastr.success("Success", "Pairing code has been created");
    } catch (error) {
      //console.log("error", error);
      dispatch(asyncActionError());
      toastr.error("Oops", "Something went wrong");
    }
  };
};

const generateOutletId = async (merchantUid, firestore) => {
  // const firestore = getFirestore();

  // const merchantsRef = firestore.collection("merchants").doc(merchantUid);

  const outletsRef = firestore
    .collection("merchants")
    .doc(merchantUid)
    .collection("outlets");

  let outletCount = await outletsRef.get().then((querySnap) => {
    return querySnap.size;
  });

  let nextOutletNumber = `${outletCount + 1}`;

  nextOutletNumber =
    nextOutletNumber > 9 ? nextOutletNumber : "0" + nextOutletNumber;

  let nextId = `${merchantUid}-${nextOutletNumber}`;

  //console.log("nextId", nextId);

  return nextId;
};

export const changeMACAddressAction = (values) => {
  return async (dispatch, getState, { getFirebase, getFirestore }) => {
    const firebase = getFirebase();
    const firestore = getFirestore();
    const currentUser = firebase.auth().currentUser.displayName;

    const now = new Date();

    //console.log("values.computerId", values);

    try {
      dispatch(asyncActionStart());
      let currentComputerOjectRef = await firestore
        .collection("outlet_computers")
        .doc(values.computerId);

      let macAdressObject = await currentComputerOjectRef.get().then((doc) => {
        return {
          account: doc.data().account,
          createdBy: currentUser,
          dateCreated: now,
          dateEnabled: doc.data().dateEnabled,
          deviceType: doc.data().deviceType,
          enabledBy: doc.data().enabledBy,
          isEnabled: doc.data().isEnabled,
          macAddress: values.macAddress,
          merchantName: doc.data().merchantName,
          name: doc.data().name,
          outletId: doc.data().outletId,
          outletName: doc.data().outletName,
          reportsUser: doc.data().reportsUser,
          reportsUserPassword: doc.data().reportsUserPassword,
        };
      });

      //console.log("macAdressObject", macAdressObject);

      let newComputerOjectRef = firestore
        .collection("outlet_computers")
        .doc(values.macAddress);

      let batch = firestore.batch();

      // Add it in the batch
      await batch.set(newComputerOjectRef, macAdressObject);

      await batch.delete(currentComputerOjectRef);

      await batch.commit();

      dispatch(closeModal());
      dispatch(asyncActionFinish());
      toastr.success("Success", "Computer has been updated");
    } catch (error) {
      dispatch(asyncActionError());
      toastr.error("Oops", "Something went wrong");
    }
  };
};

export const disableComputerAction = (computerId) => {
  return async (dispatch, getState, { getFirebase, getFirestore }) => {
    const firebase = getFirebase();
    const firestore = getFirestore();
    const currentUser = firebase.auth().currentUser.displayName;

    const now = new Date();

    try {
      dispatch(asyncActionStart());
      await firestore.collection("outlet_computers").doc(computerId).set(
        {
          isEnabled: false,
          enabledBy: currentUser,
          dateEnabled: now,
        },
        { merge: true }
      );

      dispatch(closeModal());
      dispatch(asyncActionFinish());
      toastr.success("Success", "Computer has been updated");
    } catch (error) {
      dispatch(asyncActionError());
      toastr.error("Oops", "Something went wrong");
    }
  };
};

export const enableComputerAction = (computerId) => {
  return async (dispatch, getState, { getFirebase, getFirestore }) => {
    const firebase = getFirebase();
    const firestore = getFirestore();
    const currentUser = firebase.auth().currentUser.displayName;

    const now = new Date();

    try {
      dispatch(asyncActionStart());
      await firestore.collection("outlet_computers").doc(computerId).set(
        {
          isEnabled: true,
          enabledBy: currentUser,
          dateEnabled: now,
        },
        { merge: true }
      );

      dispatch(closeModal());
      dispatch(asyncActionFinish());
      toastr.success("Success", "Computer has been updated");
    } catch (error) {
      dispatch(asyncActionError());
      toastr.error("Oops", "Something went wrong");
    }
  };
};

const generateMerchantAccount = async (firestore) => {
  let d = new Date();

  let month = d.getMonth() + 1;
  month = month > 9 ? month : "0" + month;

  let year = d.getFullYear().toString().substr(2, 2);

  let currentMonth = d.getMonth();
  let currentYear = d.getFullYear();

  let startDate = new Date(Date.UTC(currentYear, currentMonth, 1, 0, 0, 0, 0));
  let endDate = new Date(
    Date.UTC(currentYear, currentMonth + 1, 0, 0, 0, 0, 0)
  );

  // Date(Date.UTC(2019, 2, 0, 0, 0, 0));

  let merchantCount = await firestore
    .collection("merchants")
    .where("dateCreated", ">=", startDate)
    .where("dateCreated", "<=", endDate)
    .get()
    .then((snap) => {
      return snap.size; // will return the collection size
    });

  merchantCount = merchantCount + 1;

  merchantCount = merchantCount > 9 ? merchantCount : "0" + merchantCount;

  let merchantId = `${year}${month}${merchantCount}`;
  //let outletId = `${merchantId}-01`
  return merchantId;
};

export const registerMerchantDeviceAction = (computer) => {
  return async (dispatch, getState, { getFirebase, getFirestore }) => {
    const firebase = getFirebase();
    const firestore = getFirestore();
    const user = firebase.auth().currentUser.displayName;

    //console.log("computer", computer);
    let outletComputer = createMerchantComputerObject(computer, user);

    try {
      dispatch(asyncActionStart());

      await firestore
        .collection("outlet_computers")
        .doc(outletComputer.macAddress)
        .set(outletComputer);

      dispatch(closeModal());
      dispatch(asyncActionFinish());
      toastr.success("Success", "Computer has been created");
    } catch (error) {
      dispatch(asyncActionError());
      toastr.error("Oops", "Something went wrong");
    }
  };
};

export const changePortalUserPassword =
  (values, email) =>
  async (dispatch, getState, { getFirebase }) => {
    const firebase = getFirebase();
    const curentUser = firebase.auth().currentUser.displayName;

    //console.log("email", email);

    try {
      dispatch(asyncActionStart());

      let response = await axios
        .post("api/updateuserpassword", {
          email: email,
          password: values.password,
          curentUser: curentUser,
        })
        .then((response) => {
          return response;
        });

      //console.log("response", response);

      // dispatch(closeModal());
      dispatch(asyncActionFinish());
      toastr.success("Success", response.data.Message);
    } catch (error) {
      //console.log("error.message", error.message);
      dispatch(asyncActionError());
      throw new SubmissionError({
        _error: error.message,
      });
    }
  };

export const changePortalUserName =
  (values, uid) =>
  async (dispatch, getState, { getFirebase }) => {
    const firebase = getFirebase();

    const currentUser = firebase.auth().currentUser.displayName;

    try {
      dispatch(asyncActionStart());

      let response = await axios
        .post("api/updateUserName", {
          uid: uid,
          displayName: values.displayName,
          currentUser: currentUser,
        })
        .then((response) => {
          return response;
        });

      // dispatch(closeModal());
      dispatch(asyncActionFinish());
      toastr.success("Success", response.data.Message);
    } catch (error) {
      dispatch(asyncActionError());
      throw new SubmissionError({
        _error: error.message,
      });
    }
  };

export const enablePortalUser = (uid) => {
  return async (dispatch, getState, { getFirebase, getFirestore }) => {
    dispatch(asyncActionStart());

    const firebase = getFirebase();

    //console.log("uid", uid);

    const currentUser = firebase.auth().currentUser.displayName;

    try {
      await axios
        .post("/enablePortalUser", {
          uid: uid,
          currentUser: currentUser,
        })
        .then((response) => {
          return response;
        });

      dispatch(closeModal());
      dispatch(asyncActionFinish());
      toastr.success("Success", "User has been enable");
    } catch (error) {
      dispatch(asyncActionError());
      toastr.error("Oops", "Something went wrong");
    }
  };
};

export const disablePortalUser = (uid) => {
  return async (dispatch, getState, { getFirebase, getFirestore }) => {
    dispatch(asyncActionStart());

    const firebase = getFirebase();

    //console.log("uid", uid);

    const currentUser = firebase.auth().currentUser.displayName;

    try {
      await axios
        .post("/disablePortalUser", {
          uid: uid,
          currentUser: currentUser,
        })
        .then((response) => {
          return response;
        });

      dispatch(closeModal());
      dispatch(asyncActionFinish());
      toastr.success("Success", "User has been disabled");
    } catch (error) {
      dispatch(asyncActionError());
      toastr.error("Oops", "Something went wrong");
    }
  };
};

export const enableProviderAction = (uid) => {
  return async (dispatch, getState, { getFirebase, getFirestore }) => {
    dispatch(asyncActionStart());
    const firebase = getFirebase();
    const firestore = getFirestore();
    const currentUser = firebase.auth().currentUser.displayName;

    const now = new Date();

    try {
      await firestore.collection("providers").doc(uid).set(
        {
          isEnabled: true,
          enabledBy: currentUser,
          dateEnabled: now,
        },
        { merge: true }
      );

      dispatch(closeModal());
      dispatch(asyncActionFinish());
      toastr.success("Success", "Provider has been updated");
    } catch (error) {
      dispatch(asyncActionError());
      toastr.error("Oops", "Something went wrong");
    }
  };
};

export const disableProviderAction = (uid) => {
  return async (dispatch, getState, { getFirebase, getFirestore }) => {
    dispatch(asyncActionStart());
    const firebase = getFirebase();
    const firestore = getFirestore();
    const currentUser = firebase.auth().currentUser.displayName;

    const now = new Date();

    try {
      await firestore.collection("providers").doc(uid).set(
        {
          isEnabled: false,
          enabledBy: currentUser,
          dateEnabled: now,
        },
        { merge: true }
      );

      dispatch(closeModal());
      dispatch(asyncActionFinish());
      toastr.success("Success", "Provider has been updated");
    } catch (error) {
      dispatch(asyncActionError());
      toastr.error("Oops", "Something went wrong");
    }
  };
};

export const enableProviders = (values, account) => {
  return async (dispatch, getState, { getFirebase, getFirestore }) => {
    dispatch(asyncActionStart());
    const firebase = getFirebase();
    const firestore = getFirestore();
    const currentUser = firebase.auth().currentUser.displayName;

    const now = new Date();

    let airtime = [];

    const providers = [];

    let providerDetails = [];

    const transactionsRef = firestore.collection("providers");
    try {
      dispatch(asyncActionStart());
      if (values.id === "airtimeVoucher" || values.id === "airtimePinless") {
        await transactionsRef
          .where("account", "==", account)
          .where("type", "==", "Airtime")
          .get()
          .then((querySnapshot) => {
            if (querySnapshot.size > 0) {
              querySnapshot.docs.map((doc) => {
                let provider = doc.data();
                provider.id = doc.id;
                airtime.push(provider);
              });
            }
          });

        if (values.id === "airtimeVoucher") {
          const excludedProviders = ["Orange-500", "Mascom-500", "beMobile-250","Orange-250", "Mascom-250", "beMobile-250","BTC"];
          airtime.map((record) => {
            if (record.provider.includes("Pinless") != true && !excludedProviders.includes(record.provider)) {
              providers.push(record);
            }
          });
        }

        if (values.id === "airtimePinless") {
          airtime.map((record) => {
            if (record.provider.includes("Pinless")) {
              providers.push(record);
            }
          });
        }
      }

      if (values.id === "MultiChoice Botswana") {
        await transactionsRef
          .where("account", "==", account)
          .where("provider", "==", values.id)
          .get()
          .then((querySnapshot) => {
            if (querySnapshot.size > 0) {
              querySnapshot.docs.map((doc) => {
                let provider = doc.data();
                provider.id = doc.id;
                providers.push(provider);
              });
            }
          });
      }

      if (values.id === "WUC") {
        await transactionsRef
          .where("account", "==", account)
          .where("provider", "==", "Water Utilities Corporation")
          .get()
          .then((querySnapshot) => {
            if (querySnapshot.size > 0) {
              querySnapshot.docs.map((doc) => {
                let provider = doc.data();
                provider.id = doc.id;
                providers.push(provider);
              });
            }
          });
      }

      if (values.id === "BPC") {
        await transactionsRef
          .where("account", "==", account)
          .where("provider", "==", values.id)
          .get()
          .then((querySnapshot) => {
            if (querySnapshot.size > 0 ) {
              querySnapshot.docs.map((doc) => {
                if (doc.data().type === "Electricity") {
                  let provider = doc.data();
                  provider.id = doc.id;
                  providers.push(provider);
                }
              });
            }
          });
      }

      if (values.id === "Gambling") {
        await transactionsRef
          .where("account", "==", account)
          .where("provider", "==", values.id)
          .get()
          .then((querySnapshot) => {
            if (querySnapshot.size > 0) {
              querySnapshot.docs.map((doc) => {
                let provider = doc.data();
                provider.id = doc.id;
                providers.push(provider);
              });
            }
          });
      }

      if (values.id === "Botswana Life") {
        await transactionsRef
          .where("account", "==", account)
          .where("provider", "==", values.id)
          .get()
          .then((querySnapshot) => {
            if (querySnapshot.size > 0) {
              querySnapshot.docs.map((doc) => {
                let provider = doc.data();
                provider.id = doc.id;
                providers.push(provider);
              });
            }
          });
      }

      if (values.id === "Assure Wealth") {
        await transactionsRef
          .where("account", "==", account)
          .where("provider", "==", values.id)
          .get()
          .then((querySnapshot) => {
            if (querySnapshot.size > 0) {
              querySnapshot.docs.map((doc) => {
                let provider = doc.data();
                provider.id = doc.id;
                providers.push(provider);
              });
            }
          });
      }

      if (values.id === "Badiphitlho") {
        await transactionsRef
          .where("account", "==", account)
          .where("provider", "==", values.id)
          .get()
          .then((querySnapshot) => {
            if (querySnapshot.size > 0) {
              querySnapshot.docs.map((doc) => {
                let provider = doc.data();
                provider.id = doc.id;
                providers.push(provider);
              });
            }
          });
      }


      if (providerDetails.length > 0) {
        await transactionsRef
          .where("account", "==", account)
          .where("type", "in", providerDetails)
          .get()
          .then((querySnapshot) => {
            if (querySnapshot.size > 0) {
              querySnapshot.docs.map((doc) => {
                let provider = doc.data();
                provider.id = doc.id;
                providers.push(provider);
              });
            }
          });
      }

      let batch = firestore.batch();
      providers.forEach(async (provider) => {
        let providersRef = firestore.collection("providers").doc(provider.id);

        await batch.update(providersRef, {
          isEnabled: true,
          dateEnabled: now,
          enabledBy: currentUser,
        });
      });

      await batch.commit();

      dispatch(closeModal());
      dispatch(asyncActionFinish());
      toastr.success("Success", "Providers have been updated");
    } catch (error) {
      dispatch(asyncActionError());
      toastr.error("Oops", "Something went wrong");
    }
  };
};

export const disableProviders = (values, account) => {
  return async (dispatch, getState, { getFirebase, getFirestore }) => {
    dispatch(asyncActionStart());
    const firebase = getFirebase();
    const firestore = getFirestore();
    const currentUser = firebase.auth().currentUser.displayName;

    const now = new Date();

    let airtime = [];

    const providers = [];

    let providerDetails = [];

    const transactionsRef = firestore.collection("providers");

    try {
      dispatch(asyncActionStart());
      if (values.id === "airtimeVoucher" || values.id === "airtimePinless") {
        await transactionsRef
          .where("account", "==", account)
          .where("type", "==", "Airtime")
          .get()
          .then((querySnapshot) => {
            if (querySnapshot.size > 0) {
              querySnapshot.docs.map((doc) => {
                let provider = doc.data();
                provider.id = doc.id;
                airtime.push(provider);
              });
            }
          });

        if (values.id === "airtimeVoucher") {
          airtime.map((record) => {
            if (record.provider.includes("Pinless") != true) {
              providers.push(record);
            }
          });
        }

        if (values.id === "airtimePinless") {
          airtime.map((record) => {
            if (record.provider.includes("Pinless")) {
              providers.push(record);
            }
          });
        }
      }

      if (values.id === "MultiChoice Botswana") {
        await transactionsRef
          .where("account", "==", account)
          .where("provider", "==", values.id)
          .get()
          .then((querySnapshot) => {
            if (querySnapshot.size > 0) {
              querySnapshot.docs.map((doc) => {
                let provider = doc.data();
                provider.id = doc.id;
                providers.push(provider);
              });
            }
          });
      }

      if (values.id === "WUC") {
        await transactionsRef
          .where("account", "==", account)
          .where("provider", "==", "Water Utilities Corporation")
          .get()
          .then((querySnapshot) => {
            if (querySnapshot.size > 0) {
              querySnapshot.docs.map((doc) => {
                let provider = doc.data();
                provider.id = doc.id;
                providers.push(provider);
              });
            }
          });
      }

      if (values.id === "BPC") {
        await transactionsRef
          .where("account", "==", account)
          .where("provider", "==", values.id)
          .get()
          .then((querySnapshot) => {
            if (querySnapshot.size > 0) {
              querySnapshot.docs.map((doc) => {
                let provider = doc.data();
                provider.id = doc.id;
                providers.push(provider);
              });
            }
          });
      }

      if (values.id === "Gambling") {
        await transactionsRef
          .where("account", "==", account)
          .where("provider", "==", values.id)
          .get()
          .then((querySnapshot) => {
            if (querySnapshot.size > 0) {
              querySnapshot.docs.map((doc) => {
                let provider = doc.data();
                provider.id = doc.id;
                providers.push(provider);
              });
            }
          });
      }

      if (values.id === "Botswana Life") {
        await transactionsRef
          .where("account", "==", account)
          .where("provider", "==", values.id)
          .get()
          .then((querySnapshot) => {
            if (querySnapshot.size > 0) {
              querySnapshot.docs.map((doc) => {
                let provider = doc.data();
                provider.id = doc.id;
                providers.push(provider);
              });
            }
          });
      }

      if (values.id === "Assure Wealth") {
        await transactionsRef
          .where("account", "==", account)
          .where("provider", "==", values.id)
          .get()
          .then((querySnapshot) => {
            if (querySnapshot.size > 0) {
              querySnapshot.docs.map((doc) => {
                let provider = doc.data();
                provider.id = doc.id;
                providers.push(provider);
              });
            }
          });
      }

      if (values.id === "Badiphitlho") {
        await transactionsRef
          .where("account", "==", account)
          .where("provider", "==", values.id)
          .get()
          .then((querySnapshot) => {
            if (querySnapshot.size > 0) {
              querySnapshot.docs.map((doc) => {
                let provider = doc.data();
                provider.id = doc.id;
                providers.push(provider);
              });
            }
          });
      }

      if (providerDetails.length > 0) {
        await transactionsRef
          .where("account", "==", account)
          .where("type", "in", providerDetails)
          .get()
          .then((querySnapshot) => {
            if (querySnapshot.size > 0) {
              querySnapshot.docs.map((doc) => {
                let provider = doc.data();
                provider.id = doc.id;
                providers.push(provider);
              });
            }
          });
      }

      let batch = firestore.batch();
      providers.forEach(async (provider) => {
        let providersRef = firestore.collection("providers").doc(provider.id);

        await batch.update(providersRef, {
          isEnabled: false,
          dateEnabled: firebase.firestore.FieldValue.delete(),
          enabledBy: firebase.firestore.FieldValue.delete(),
        });
      });

      await batch.commit();

      dispatch(closeModal());
      dispatch(asyncActionFinish());
      toastr.success("Success", "Providers have been updated");
    } catch (error) {
      dispatch(asyncActionError());
      toastr.error("Oops", "Something went wrong");
    }
  };
};

// let merchantProviders = [
//   {
//     account: merchantAccount,
//     type: "Airtime",
//     provider: "Mascom",
//     name: newMerchant.name,
//     isEnabled: false,
//     dateCreated: dateCreated,
//     createdBy: currentUser
//   },
//   {
//     account: merchantAccount,
//     type: "Airtime",
//     provider: "Orange",
//     name: newMerchant.name,
//     isEnabled: false,
//     dateCreated: dateCreated,
//     createdBy: currentUser
//   },
//   {
//     account: merchantAccount,
//     type: "Airtime",
//     provider: "BeMobile",
//     name: newMerchant.name,
//     isEnabled: false,
//     dateCreated: dateCreated,
//     createdBy: currentUser
//   },
//   {
//     account: merchantAccount,
//     type: "Airtime",
//     provider: "BTC",
//     name: newMerchant.name,
//     isEnabled: false,
//     dateCreated: dateCreated,
//     createdBy: currentUser
//   },
//   {
//     account: merchantAccount,
//     type: "Electricity",
//     provider: "BPC",
//     name: newMerchant.name,
//     isEnabled: true,
//     dateCreated: dateCreated,
//     createdBy: currentUser
//   },
//   {
//     account: merchantAccount,
//     type: "Collections",
//     provider: "BLIL",
//     name: newMerchant.name,
//     isEnabled: false,
//     dateCreated: dateCreated,
//     createdBy: currentUser
//   },
//   {
//     account: merchantAccount,
//     type: "Bills",
//     provider: "BTC",
//     name: newMerchant.name,
//     isEnabled: false,
//     dateCreated: dateCreated,
//     createdBy: currentUser
//   },
//   {
//     account: merchantAccount,
//     type: "Bills",
//     provider: "DSTV",
//     name: newMerchant.name,
//     isEnabled: false,
//     dateCreated: dateCreated,
//     createdBy: currentUser
//   },
//   {
//     account: merchantAccount,
//     type: "Bills",
//     provider: "WUC",
//     name: newMerchant.name,
//     isEnabled: false,
//     dateCreated: dateCreated,
//     createdBy: currentUser
//   },
//   {
//     account: merchantAccount,
//     type: "Bills",
//     provider: "BPC",
//     name: newMerchant.name,
//     isEnabled: false,
//     dateCreated: dateCreated,
//     createdBy: currentUser
//   }
// ];
